let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("g4FYy"), load("k9ktU")]).then(() => parcelRequire('iFaMg'));